import React from 'react';
import styled from 'styled-components';

export type Props = {
  children?: React.ReactNode,
}

const Main = styled.aside`
  & > * {
    margin-top: 5rem;
  }

  & > *:first-child {
    margin-top: 0;
  }
`;

const Sidebar: React.FC<Props> = ({
  children,
}) => (
  <Main data-test="sidebar">
    {children}
  </Main>
);

export default Sidebar;
